var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c(
            "h3",
            [
              _vm.prestamoRefId
                ? [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.tipoPrestamo === "RN"
                            ? "Renovación de "
                            : "Refinanciamiento de "
                        )
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v("\n        Préstamo "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.selectedCliente !== null
                      ? _vm.selectedCliente.solo_descripcion ||
                          _vm.selectedCliente.descripcion.split("(")[0].trim()
                      : ""
                  )
                )
              ])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "datepicker-field" },
              [
                _c("VueCtkDateTimePicker", {
                  attrs: {
                    id: "fecha_desembolso",
                    locale: "es",
                    "no-label": "",
                    "button-now-translation": "Ahora",
                    format: "YYYY-MM-DD HH:mm",
                    formatted: "YYYY-MM-DD HH:mm",
                    label: "Seleccione fecha..."
                  },
                  model: {
                    value: _vm.form.fecha_desembolso,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "fecha_desembolso", $$v)
                    },
                    expression: "form.fecha_desembolso"
                  }
                }),
                _vm._v(" "),
                _c("label", [_vm._v("Fecha de desembolso")])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            {
              staticClass: "form-field select2",
              class: { "select2--readonly": _vm.prestamoRefId != "" }
            },
            [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "cliente",
                      placeholder: "Seleccione...",
                      options: _vm.clientes,
                      label: "descripcion"
                    },
                    on: {
                      search: _vm.onSearchClientes,
                      input: _vm.inputCliente
                    },
                    model: {
                      value: _vm.selectedCliente,
                      callback: function($$v) {
                        _vm.selectedCliente = $$v
                      },
                      expression: "selectedCliente"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "cliente" } }, [
                    _vm._v("Cliente")
                  ]),
                  _vm._v(" "),
                  _vm.errores.cliente_id
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.cliente_id[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            {
              staticClass: "form-field select2",
              class: {
                "select2--disabled": _vm.prestamoRefId != "" || _vm.ruta
              }
            },
            [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "ruta_id",
                      options: _vm.rutas,
                      label: "descripcion"
                    },
                    on: { input: _vm.inputRuta, search: _vm.onSearchRutas },
                    model: {
                      value: _vm.selectedRuta,
                      callback: function($$v) {
                        _vm.selectedRuta = $$v
                      },
                      expression: "selectedRuta"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "ruta" } }, [_vm._v("Ruta")]),
                  _vm._v(" "),
                  _vm.errores.ruta_id
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.ruta_id[0]))])]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.periodo,
                      expression: "form.periodo"
                    }
                  ],
                  attrs: { name: "periodo", id: "tipo_identificacion" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "periodo",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Seleccione...")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "D" } }, [_vm._v("Diario")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "S" } }, [_vm._v("Semanal")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "M" } }, [_vm._v("Mensual")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "periodo" } }, [_vm._v("Período")]),
              _vm._v(" "),
              _vm.errores.periodo
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.periodo[0]))])]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.form.periodo === "M"
          ? _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        vMoney: "",
                        format: _vm.int,
                        placeholder: "Escriba el día de cobro...",
                        id: "dia_cobro"
                      },
                      model: {
                        value: _vm.form.dia_cobro,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dia_cobro", $$v)
                        },
                        expression: "form.dia_cobro"
                      }
                    },
                    [
                      _vm._v("\n          Día de cobro\n          "),
                      _vm.errores.dia_cobro
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.dia_cobro[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.periodo === "S"
          ? _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.dia_cobro,
                          expression: "form.dia_cobro"
                        }
                      ],
                      attrs: { id: "dia_cobro" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "dia_cobro",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "", disabled: "" } }, [
                        _vm._v("Seleccione...")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Lunes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("Martes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "3" } }, [
                        _vm._v("Miércoles")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "4" } }, [
                        _vm._v("Jueves")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "5" } }, [
                        _vm._v("Viernes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "6" } }, [
                        _vm._v("Sábado")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "dia_cobro" } }, [
                    _vm._v("Día de cobro")
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money,
                    placeholder: "Escriba un valor...",
                    id: "valor",
                    readonly: _vm.tipoPrestamo === "RF"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.generarAmortizaciones.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.form.valor,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "valor", $$v)
                    },
                    expression: "form.valor"
                  }
                },
                [
                  _vm._v("\n          Valor\n          "),
                  _vm.errores.valor
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.valor[0]))])]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.porcentaje,
                    readonly: !_vm.puedeCambiarInteres,
                    placeholder: "Escriba un % interés...",
                    id: "porc_interes"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.generarAmortizaciones.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.form.porc_interes,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "porc_interes", $$v)
                    },
                    expression: "form.porc_interes"
                  }
                },
                [
                  _vm._v("\n          % Interés\n          "),
                  _vm.errores.porc_interes
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.porc_interes[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    readonly: "",
                    vMoney: "",
                    format: _vm.money,
                    placeholder: "Total calculado...",
                    id: "total",
                    value: _vm.total
                  }
                },
                [
                  _vm._v("\n          Total\n          "),
                  _vm.errores.total
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.total[0]))])]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.int,
                    placeholder: "Escriba la cantidad de cuotas...",
                    id: "cuotas"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.generarAmortizaciones.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.form.cuotas,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "cuotas", $$v)
                    },
                    expression: "form.cuotas"
                  }
                },
                [
                  _vm._v("\n          Cuotas\n          "),
                  _vm.errores.cuotas
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.cuotas[0]))])]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Direcciones")]),
                  _vm._v(" "),
                  _c("th", [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-success",
                          attrs: { type: "button" },
                          on: { click: _vm.agregarDireccion }
                        },
                        [_c("i", { staticClass: "fa fa-plus" })]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.form.direcciones, function(direccion, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c("input-field", {
                              attrs: { id: "direccion" + index },
                              model: {
                                value: direccion.direccion,
                                callback: function($$v) {
                                  _vm.$set(direccion, "direccion", $$v)
                                },
                                expression: "direccion.direccion"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-danger btn--text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.eliminarDireccion(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.direcciones.length === 0,
                          expression: "form.direcciones.length === 0"
                        }
                      ]
                    },
                    [_vm._m(0)]
                  )
                ],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-xs-12 col-md-6",
            staticStyle: { "max-height": "420px", "overflow-y": "auto" }
          },
          [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.form.amortizaciones, function(
                      amortizacion,
                      index
                    ) {
                      return _c("tr", { key: index }, [
                        _c("th", { attrs: { scope: "row" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(amortizacion.cuota) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(amortizacion.valor, 2)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.moneyFormat(amortizacion.total_pagado, 2)
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(amortizacion.saldo, 2)) +
                              "\n              "
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.amortizaciones.length === 0,
                            expression: "form.amortizaciones.length === 0"
                          }
                        ]
                      },
                      [_vm._m(2)]
                    )
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _vm.prestamoId != ""
          ? _c(
              "button",
              { staticClass: "btn-secondary", on: { click: _vm.auditoria } },
              [
                _c("i", { staticClass: "fa fa-list" }),
                _c("span", [_vm._v("Auditoría")])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn-success", on: { click: _vm.guardar } },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _c("span", [_vm._v("Guardar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cancelar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "auditoriaPrestamo",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [_c("auditoria-prestamo", { attrs: { prestamoId: _vm.prestamoId } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("strong", [_vm._v("No se ha agregado dirección alguna...")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cuota")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total pagado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("strong", [_vm._v("No se ha generado amortizaciones...")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2173ed71", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2173ed71","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/Prestamo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2173ed71","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/Prestamo.vue
// module chunks = 0